var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"color":"primary lighten-1","padless":""}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("Nemanja Đokić")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }